const API = process.env.REACT_APP_BACKEND_URL + "/api";
async function req(path, opts = {}) {
  const r = await fetch(API + path, { credentials: "include", headers: { "Content-Type": "application/json", ...(opts.headers || {}) }, ...opts });
  if (!r.ok) { const t = await r.text(); throw new Error(t || r.statusText); }
  return r.status === 204 ? null : r.json();
}
export const api = {
  me: () => req("/auth/me"),
  session: (session_id) => req("/auth/session", { method: "POST", body: JSON.stringify({ session_id }) }),
  logout: () => req("/auth/logout", { method: "POST" }),
  overview: () => req("/overview"),
  team: {
    list: () => req("/team"),
    add: (b) => req("/team", { method: "POST", body: JSON.stringify(b) }),
    update: (id, b) => req(`/team/${id}`, { method: "PATCH", body: JSON.stringify(b) }),
    remove: (id) => req(`/team/${id}`, { method: "DELETE" }),
  },
  entries: {
    list: (d) => req(`/departments/${d}/entries`),
    create: (d, data) => req(`/departments/${d}/entries`, { method: "POST", body: JSON.stringify({ department: d, data }) }),
    update: (d, id, data, known_version) => req(`/departments/${d}/entries/${id}`, { method: "PATCH", body: JSON.stringify({ data, known_version }) }),
    status: (d, id, status, known_version) => req(`/departments/${d}/entries/${id}/status`, { method: "POST", body: JSON.stringify({ status, known_version }) }),
    markReleased: (id, known_version) => req(`/departments/release_planning/entries/${id}/mark_released`, { method: "POST", body: JSON.stringify({ known_version }) }),
    remove: (d, id) => req(`/departments/${d}/entries/${id}`, { method: "DELETE" }),
  },
  deleted: {
    list: () => req("/recently_deleted"),
    restore: (id) => req(`/recently_deleted/${id}/restore`, { method: "POST" }),
    purge: (id) => req(`/recently_deleted/${id}`, { method: "DELETE" }),
  },
  linkedReleases: () => req("/linked_releases"),
  invite: (tid) => req(`/team/${tid}/invite`, { method: "POST" }),
  financeCsvUrl: () => process.env.REACT_APP_BACKEND_URL + "/api/finance/export.csv",
  history: (eid) => req(`/entries/${eid}/history`),
  importCsv: async (dept, file) => {
    const fd = new FormData();
    fd.append("file", file);
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/departments/${dept}/import`, {
      method: "POST", credentials: "include", body: fd,
    });
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  },
  emailStatus: () => req("/email/status"),
  digestSendNow: () => req("/digest/send_now", { method: "POST" }),
  counts: () => req("/counts"),
  notifications: () => req("/notifications"),
  changeRequests: {
    list: () => req("/change-requests"),
    approve: (id, note = "", data = null) => req(`/change-requests/${id}/approve`, { method: "POST", body: JSON.stringify(data ? { note, data } : { note }) }),
    schema: (dept) => req(`/departments/${dept}/schema`),
    reject: (id, note = "") => req(`/change-requests/${id}/reject`, { method: "POST", body: JSON.stringify({ note }) }),
  },
  coverArt: {
    upload: async (eid, file) => {
      const fd = new FormData();
      fd.append("file", file);
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/released-songs/${eid}/cover-art`, {
        method: "POST", credentials: "include", body: fd,
      });
      if (!r.ok) throw new Error(await r.text());
      return r.json();
    },
    remove: (eid) => req(`/released-songs/${eid}/cover-art`, { method: "DELETE" }),
    urlFor: (path) => path ? `${process.env.REACT_APP_BACKEND_URL}/api/files/covers/${path}` : "",
  },
};
